import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Lecture } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Add Course Lecture
 * @param course_id
 * @param version
 * @param sectionId
 * @param title
 * @param preview
 * @param duration
 */
const addCourseLecture = (
  course_id: string,
  version: number,
  sectionId: string,
  title: string,
  preview: boolean,
  duration: Number
): Promise<Lecture> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { title, preview, duration }

    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default addCourseLecture
